import React, { PropTypes } from "react";
import InsurerSection from "./InsurerSection";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import { SelectInput, TextInput } from "../../../../common/form";
import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";
const InsurerContact = () => (
  <InsurerSection>
    <h3>
      <FormattedMessage id="admin.insurers.form.contacts.adminTitle" />
    </h3>
    <Field
      id="adminContactFullName"
      name="adminContactFullName"
      component={TextInput}
      type="text"
      label={<FormattedMessage id="admin.insurers.form.contacts.fullName" />}
    />
    <Field
      id="adminContactEmailAddress"
      name="adminContactEmailAddress"
      component={TextInput}
      type="text"
      label={
        <FormattedMessage id="admin.insurers.form.contacts.emailAddress" />
      }
    />
    <Field
      id="adminContactPhoneNumber"
      name="adminContactPhoneNumber"
      component={TextInput}
      type="text"
      maxLength="25"
      label={<FormattedMessage id="admin.insurers.form.contacts.phoneNumber" />}
    />
    <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
      <Field
        id="adminContactLlanguageCode"
        name="adminContactLanguageCode"
        component={SelectInput}
        addBlankOption={true}
        label={<FormattedMessage id="admin.insurers.form.contacts.language" />}
      />
    </EnumWrapper>

    <h3>
      <FormattedMessage id="admin.insurers.form.contacts.salesTitle" />
    </h3>
    <Field
      id="salesContactFullName"
      name="salesContactFullName"
      component={TextInput}
      type="text"
      label={<FormattedMessage id="admin.insurers.form.contacts.fullName" />}
    />
    <Field
      id="salesContactEmailAddress"
      name="salesContactEmailAddress"
      component={TextInput}
      type="text"
      label={
        <FormattedMessage id="admin.insurers.form.contacts.emailAddress" />
      }
    />
    <Field
      id="salesContactPhoneNumber"
      name="salesContactPhoneNumber"
      component={TextInput}
      type="text"
      maxLength="25"
      label={<FormattedMessage id="admin.insurers.form.contacts.phoneNumber" />}
    />
    <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
      <Field
        id="salesContactLanguageCode"
        name="salesContactLanguageCode"
        component={SelectInput}
        addBlankOption={true}
        label={<FormattedMessage id="admin.insurers.form.contacts.language" />}
      />
    </EnumWrapper>
  </InsurerSection>
);

InsurerContact.propTypes = {
  translateFn: PropTypes.func,
};

export default InsurerContact;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/formSections/InsurerContact.js